import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'prettifyJson'
})
export class PrettifyJsonPipe implements PipeTransform {

	transform(value: unknown, ...args: unknown[]): unknown {
		if (!value) {
			return '';
		}

		return JSON.stringify(value, null, 2);
	}

}
